import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { loadRecipients } from '../../../redux/actions/recipient.actions';
import { loadDonors } from '../../../redux/actions/donor.actions';
import { loadStudentStatuses, loadSupportedCurrencies } from '../../../redux/actions/general.actions';
import { loadProgresses } from '../../../redux/actions/progress.actions';

// Components
import LeftMenu from './LeftMenu';
import RecipientPage from './panel/recipient/RecipientPage';
import DonorPage from './panel/donor/DonorPage';

import ProgressModal from './modals/ProgressModal';
import RecipientModal from './modals/RecipientModal';
import DonorModal from './modals/DonorModal';
import ReceiptModal from './modals/ReceiptModal';
import ThankYouNoteModal from './modals/ThankYouNoteModal';
import ReportCardModal from './modals/ReportCardModal';
import PhotoModal from './modals/PhotoModal';
import RecipientAppModal from './modals/RecipientAppModal';
import RecipientMiscDocModal from './modals/RecipientMiscDocModal';
import DonationModal from './modals/DonationModal';
import DonorRecipientModal from './modals/DonorRecipientModal';
import DonorEmailUpdateModal from './modals/DonorEmailUpdate';

class Dashboard extends React.Component {
    async componentDidMount() {
        const { loadRecipients, loadDonors, loadStudentStatuses, loadSupportedCurrencies, user, loadProgresses, match: { params: { progressId, clientId }}} = this.props;
        const requests = [
            () => loadRecipients(),
            () => loadStudentStatuses(),
            () => loadSupportedCurrencies()
        ];
        if (user.data.is_super_admin || user.data.is_corporate_admin) {
            requests.push(() => loadDonors());
        }
        if (progressId) {
            requests.push(() => loadProgresses(clientId));
        }
        try {
            requests.forEach(request => request());
        } catch (err) {
            console.error(err);
        }
    }
    render() {
        const { clientType } = this.props.match.params;
        return (
            <Fragment>
                <div className="dashboard">
                    <LeftMenu />
                    { !clientType || clientType === 'recipients' ?
                        <RecipientPage /> :
                        <DonorPage />
                    }
                </div>

                {/* Modals */}
                <RecipientModal />
                <DonorRecipientModal />
                <DonorEmailUpdateModal />
                <DonationModal />
                <DonorModal />
                <ProgressModal />
                <ReceiptModal />
                <ThankYouNoteModal />
                <ReportCardModal />
                <PhotoModal />
                <RecipientAppModal />
                <RecipientMiscDocModal />
            </Fragment>
        )
    }
}

export default withRouter(connect(
    (state) => ({
        user: state.user
    }),
    { loadRecipients, loadStudentStatuses, loadSupportedCurrencies, loadProgresses, loadDonors }
)(Dashboard));


// WEBPACK FOOTER //
// ./src/components/main/dashboard/Dashboard.jsx